import moment from "moment";

const sampleGroupName = ["AGLS", "Apollo Active", "New IELTS"];

const sampleKOC = ["Kindergarten", "Primary", "IELTS 2020"];

const sampleClassStatus = ["Closed", "Finished", "Planning", "In Progress"];

const randomValueBySample = (sample) => {
  const randomIndex = Math.floor(Math.random() * sample.length); // Sửa: dùng sample.length
  return sample[randomIndex];
};

const sampleObject = {
  no: 1,
  groupKOC: randomValueBySample(sampleGroupName),
  koc: randomValueBySample(sampleKOC),
  level: Math.floor(Math.random() * 5) + 1,
  className: "Kindergarten 1",
  hubClassLink: 1,

  /*
  Schedule:
  Mon: 17.50 - 19.20
  Thu: 19.30 - 21.00*/

  schedule: ["Mon 17:50 - 19:20", "Thu 19:30 - 21:00"],
  classStatus: randomValueBySample(sampleClassStatus),
  teacher: "Carter Calzoni",
  CXO: "Giang",
  hoursWeek: 3,
  centre: "AGLS",
  startDate: moment().format("DD/MM/YYYY"),
  endOfModuleA: null,
  endOfModuleB: null,
  endOfModuleC: null,
  hoursLearned: 16,
  total: 16,
  waiting: 1,
};
export const createMockClassSituationResponse = () => {
  const mockResponse = {
    status: true,
    message: null,
    data: {
      pageSize: 10,
      totalElement: 10,
      totalPage: 5,
      currentPage: 0,
      data: [...Array(50)].map((item, index) => ({
        ...sampleObject,
        no: index + 1,
        hubClassLink: index + 1,
        groupKOC: randomValueBySample(sampleGroupName),
        koc: randomValueBySample(sampleKOC),
        classStatus: randomValueBySample(sampleClassStatus),
      })),
    },
  };

  return [
    () => Promise.resolve(mockResponse),
    { data: mockResponse, isLoading: false },
  ];
};
